import { Contact } from './contact';

export const ContactList: Contact[] = [

];
